'use client'
// import {clarity} from 'react-microsoft-clarity';
import {useEffect, useRef, useState} from "react";
import {motion} from "framer-motion";
// import {push} from "@socialgouv/matomo-next";
import mixpanel from 'mixpanel-browser';
import 'video-react/dist/video-react.css';
import {Player} from 'video-react';
import posthog from 'posthog-js'
import {handleScroll} from "~/components/handle-scroll/handle-scroll";
import FloatingTryForFree from "~/components/floating-try-for-free/floating-try-for-free";
import AppHead from "~/components/head/head";
import TopNavBar from "~/components/top-nav-bar/top-nav-bar";
import {navigateToApp} from "~/components/navigate-to-top/navigate-to-top";
import LandingBlockHowDoesItHelp
    from "~/components/landing-blocks/landing-block-how-does-it-help/landing-block-how-does-it-help";
import LandingBlockHowDoesItWork
    from "~/components/landing-blocks/landing-block-how-does-it-work/landing-block-how-does-it-work";
import LandingBlockIWantToTry
    from "~/components/landing-blocks/landing-block-i-want-to-try/landing-block-i-want-to-try";
import LandingBlockPlatforms from "~/components/landing-blocks/landing-bloc-platforms/landing-bloc-platforms";
import LandingBlockPricing from "~/components/landing-blocks/landing-block-pricing/landing-block-pricing";
import LandingBlockExplainSimpler
    from "~/components/landing-blocks/landing-block-explain-simpler/landing-block-explain-simpler";
import EmailForm from "~/components/email-form/email-form";
import Footer from "~/components/footer/footer";
import LandingBlockTopOptions from "~/components/landing-blocks/landing-block-top-options/landing-block-top-options";

// import dynamic from 'next/dynamic'
// const ReactPlayer = dynamic(() => import("react-player/file"), {ssr: false});
// const ReactPlayer = dynamic(() => import("react-player/youtube"), {ssr: false});

export default function Landing2(params: any) {
    const downloadLinks = params.downloadLinks;
    const [prevScrollPos, setPrevScrollPos] = useState(0);
    const [visibleHeader, setVisibleHeader] = useState(false)
    const [isPlayerReady, setPlayerReady] = useState(false)
    const [shouldPlay, setShouldPlay] = useState(false)
    const player = useRef<any>();


    useEffect(() => {
        // clarity.init('j9gx132pyl');
        // push(["trackEvent", "Options Landing Page Open", ""]);
        mixpanel.track('Options Landing Page Open', {
            "screen": "index-options",
        });
        posthog.capture('Options Landing Page Open', {screen: 'index'})

        window.addEventListener('scroll', () => {
            handleScroll(setVisibleHeader, setPrevScrollPos);
        });
        return () => window.removeEventListener('scroll', () => {
            handleScroll(setVisibleHeader, setPrevScrollPos);
        })
    }, []);


    // Mamoto tracking:
    // push(["trackEvent", "contact", "click phone"]);


    const trackEmailSubscription = (email: string) => {
        // push(["trackEvent", "Landing Email Subscription", email]);
        mixpanel.track('Options Landing Email Subscription', {
            "email": email,
        })

        posthog.capture('Options Landing Email Subscription', {
            "email": email,
        })
    }


    const trackVideoClick = () => {
        // push(["trackEvent", "Landing Video Play Click", ""]);
        mixpanel.track('Options Landing Video Play Click', {})

        posthog.capture('Options Landing Video Play Click', {})
    }
    const trackVideoErrorClick = () => {
        // push(["trackEvent", "Options Landing Video Error Click", ""]);
        mixpanel.track('Options Landing Video Error Click', {})

        posthog.capture('Options Landing Video Error Click', {})
    }

    const onPlayStart = () => {
        if (player?.current != null) {
            player.current.play();
            trackVideoClick();
        } else {
            trackVideoErrorClick();
        }
        setShouldPlay(true);
    }

    const onPlayerReady = function () {
        setPlayerReady(true);
    }

    return (
        <main>
            <AppHead/>

            <FloatingTryForFree visibleHeader={visibleHeader}/>

            <section className={"py-4 lg:py-8 "}>
                <TopNavBar/>

                <motion.div
                    key={"landing-block-top"}
                    initial="initial"
                    animate="animate"
                    variants={{
                        initial: {
                            opacity: 0,
                            y: 50
                        },
                        animate: {
                            opacity: 1,
                            y: 0,
                            transition: {
                                duration: 0.5,
                            }
                        },
                    }}
                >
                    <div className={"flex flex-col md:flex-row mt-10 md:mt-20 w-100"}>
                        <div className={"flex justify-center text-2xl w-full md:w-3/5 lg:w-1/2 md:pl-7 lg:pl-14 "}>
                            <div className={"mt-10 inline-block align-middle h-auto"}>
                                <LandingBlockTopOptions navigateToApp={navigateToApp}/>
                            </div>
                        </div>


                        <div
                            className={"bg-yellow-300 overflow-clip w-full md:w-2/5 lg:w-1/2 mt-10 lg:mt-0 md:rounded-l-xl"}
                            style={{paddingTop: 25}}>
                            {/*<div*/}
                            {/*    style={{height: 600, width: 350, filter: 'drop-shadow(0 0 10px rgba(0,0,0,0.3))'}}*/}
                            {/*    className={"mx-auto"}>*/}
                            {/*<Player muted={true}>*/}
                            {/*    <source src="videos/intro-ios2.mp4"/>*/}
                            {/*</Player>*/}

                            {/*    <ReactPlayer*/}
                            {/*        // url='https://youtube.com/shorts/Db5cqePJlac'*/}
                            {/*        ref={player}*/}
                            {/*        url='videos/intro-ios2.mp4'*/}
                            {/*        onStart={onPlayerReady}*/}
                            {/*        volume={0}*/}
                            {/*        width={350}*/}
                            {/*        height={700}*/}
                            {/*        muted={true}*/}
                            {/*        controls={true}*/}
                            {/*        playsinline={true}*/}
                            {/*        loop={true}*/}
                            {/*        // playing={true}*/}
                            {/*        light={*/}
                            {/*            <div onClick={onPlayStart} className={"relative"}>*/}
                            {/*                <div className={"absolute z-50 left-0 right-0 mx-auto"}*/}
                            {/*                     style={{width: 164, top: 160}}>*/}
                            {/*                    <div className={'mx-auto'}*/}
                            {/*                         style={{backgroundColor: 'rgba(0,0,0,0.7)', padding: 20, borderRadius: 100}}>*/}
                            {/*                        <div className={"mx-auto text-center"} onClick={onPlayStart}>*/}
                            {/*                            <svg onClick={onPlayStart} xmlns="http://www.w3.org/2000/svg"*/}
                            {/*                                 fill="none" viewBox="0 0 24 24"*/}
                            {/*                                 strokeWidth={1.5} stroke="white"*/}
                            {/*                                 className="w-24 h-24 mx-auto text-center">*/}
                            {/*                                <path strokeLinecap="round" strokeLinejoin="round"*/}
                            {/*                                      d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"/>*/}
                            {/*                            </svg>*/}
                            {/*                        </div>*/}
                            {/*                        <div className={"text-lg font-bold text-white mx-auto text-center"}>*/}
                            {/*                            Play Demo*/}
                            {/*                        </div>*/}
                            {/*                    </div>*/}
                            {/*                </div>*/}

                            {/*                <div className={"hidden lg:block image-feature-video-bg-desktop"}></div>*/}
                            {/*                <div className={"p-0"}>*/}
                            {/*                    <div className={"block lg:hidden image-feature-video-bg-mob"}></div>*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*        }*/}
                            {/*        // playIcon={<button className={"bg-red-500 w-20 h-10"} style={{position: 'absolute', top: 10, left: 10}}>*/}
                            {/*        //     <h1 className={"font-bold text-xl"}>Play</h1>*/}
                            {/*        //*/}
                            {/*        // </button>}*/}
                            {/*    />*/}

                            {/*    {isPlayerReady != true ?*/}
                            {/*        <div className={"mx-auto text-center text-white font-bold text-xl mt-10 "}>*/}
                            {/*            <div className={"mx-auto text-center inline-block"}>*/}
                            {/*                <svg*/}
                            {/*                    className="animate-spin -ml-1 mr-3 h-4 w-4 text-white mx-auto text-center"*/}
                            {/*                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">*/}
                            {/*                    <circle className="opacity-25" cx="12" cy="12" r="10"*/}
                            {/*                            stroke="currentColor"*/}
                            {/*                            strokeWidth="4"></circle>*/}
                            {/*                    <path className="opacity-75" fill="currentColor"*/}
                            {/*                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>*/}
                            {/*                </svg>*/}

                            {/*            </div>*/}
                            {/*            <div className={"inline-block"} style={{lineHeight: 3}}>*/}
                            {/*                Loading Demo Video...*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*        : null}*/}
                            {/*</div>*/}


                            {shouldPlay ? null : <div onClick={onPlayStart} className={"relative"}>
                                <div className={"absolute z-50 left-0 right-0 mx-auto cursor-pointer"}
                                     style={{width: 190, height: 190, top: 160}}>
                                    <div className={'mx-auto'}
                                         style={{backgroundColor: 'rgba(0,0,0,0.7)', padding: 20, borderRadius: 100}}>
                                        <div className={"mx-auto text-center"} onClick={onPlayStart}>
                                            {/*<svg onClick={onPlayStart} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"*/}
                                            {/*     strokeWidth={1.5} stroke="white" className="w-24 h-24 mx-auto text-center">*/}
                                            {/*    <path strokeLinecap="round" strokeLinejoin="round"*/}
                                            {/*          d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"/>*/}
                                            {/*</svg>*/}
                                            <img src={"graphics/play3.png"} alt={"Play"} width={100} height={100}
                                                 className={"mx-auto"}/>
                                        </div>
                                        <div className={"text-lg font-bold text-white mx-auto text-center"}>
                                            See in action
                                            <div className={"text-xs mt-1 mb-2"}>
                                                App Demo Video
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={"hidden md:block image-feature-video-bg-desktop"}></div>
                                <div className={"p-0"}>
                                    <div className={"block md:hidden image-feature-video-bg-mob"}></div>
                                </div>
                            </div>}


                            <div
                                style={{
                                    display: shouldPlay ? 'block' : 'none',
                                    height: 600,
                                    width: 350,
                                    filter: 'drop-shadow(0 0 10px rgba(0,0,0,0.3))'
                                }}
                                className={"mx-auto"}>
                                <Player width={350} height={700} muted={true} playsInline={true} ref={(p) => {
                                    player.current = p
                                }}>
                                    <source src="videos/intro-ios2.mp4"/>
                                </Player>
                                {/*<ReactPlayer*/}
                                {/*    // url='https://youtube.com/shorts/Db5cqePJlac'*/}
                                {/*    // ref={(p: any) => {*/}
                                {/*    //     console.log('REF!!', p);*/}
                                {/*    //     player.current = p;*/}
                                {/*    // }}*/}
                                {/*    ref={player}*/}
                                {/*    url='videos/intro-ios2.mp4'*/}
                                {/*    onStart={onPlayerReady}*/}
                                {/*    volume={0}*/}
                                {/*    width={350}*/}
                                {/*    height={700}*/}
                                {/*    muted={true}*/}
                                {/*    controls={true}*/}
                                {/*    playsinline={true}*/}
                                {/*    loop={true}*/}
                                {/*    playing={true}*/}
                                {/*    // playIcon={<button className={"bg-red-500 w-20 h-10"} style={{position: 'absolute', top: 10, left: 10}}>*/}
                                {/*    //     <h1 className={"font-bold text-xl"}>Play</h1>*/}
                                {/*    //*/}
                                {/*    // </button>}*/}
                                {/*/>*/}


                                {isPlayerReady != true ?
                                    <div className={"mx-auto text-center text-white font-bold text-xl mt-10 "}>
                                        <div className={"mx-auto text-center inline-block"}>
                                            <svg
                                                className="animate-spin -ml-1 mr-3 h-4 w-4 text-white mx-auto text-center"
                                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor"
                                                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>

                                        </div>
                                        <div className={"inline-block"} style={{lineHeight: 3}}>
                                            Loading Demo Video...
                                        </div>
                                    </div>
                                    : null}
                            </div>

                        </div>

                        {/*<div className={"bg-yellow-300 overflow-clip w-full md:w-2/5 lg:w-1/2 mt-10 lg:mt-0 md:rounded-l-xl"}>*/}
                        {/*    <div className={"hidden lg:block image-feature-center-1-desktop-v2"}></div>*/}
                        {/*    <div className={"p-0"}>*/}
                        {/*        <div className={"block lg:hidden image-feature-center-1-mob"}></div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>

                </motion.div>


                <motion.div
                    key={"desktop-apps-block"}
                    initial="initial"
                    animate="animate"
                    variants={{
                        initial: {
                            opacity: 0,
                            y: 50
                        },
                        animate: {
                            opacity: 1,
                            y: 0,
                            transition: {
                                delay: 0.3,
                                duration: 0.3,
                            }
                        },
                    }}
                >
                    <div className={"text-center mt-24"}>
                        <h1 className={"text-xl"}>Download for your computer:</h1>
                        <div className={"flex justify-center flex-col md:flex-row"}>
                            <img
                                onClick={() => navigateToApp(
                                    downloadLinks.mac,
                                    "macos-download", "macos-download")}
                                className={"object-contain cursor-pointer"} style={{height: 68, marginTop: 6}}
                                src={"/macos-dmg.png"} alt={"Download MacOS DMG"}/>
                            <div className={"w-3"}></div>
                            <img
                                onClick={() => navigateToApp(
                                    downloadLinks.win,
                                    "windows-download", "windows-download")}
                                className={"h-14 mt-3 object-contain cursor-pointer"}
                                src={"/windows.svg"} alt={"Download Windows Installer"}/>
                            <div className={"w-3"}></div>

                            <div
                                className={"bg-black border border-gray-400 rounded-lg cursor-pointer w-56 sm:mx-auto md:mx-0"}
                                onClick={() => navigateToApp("https://app.thebullish.trade", "app", "landing-try-in-browser")}
                                style={{height: 55, marginTop: 13, paddingTop: 3, paddingLeft: 7, paddingRight: 10}}>
                                <div className={"flex"}>
                                    <div className={"text-4xl"}
                                         style={{paddingTop: 2, paddingLeft: 1, marginRight: 10}}>
                                        🌎
                                    </div>
                                    <div className={"text-left mr-3"}>
                                        <div className={"text-sm text-white"}>Try web app in your</div>
                                        <div className={"font-bold text-lg text-white"}>Browser</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={"mt-10"}>
                            <p>
                                We have apps for all the platforms. Yes, even Linux! 🐧
                            </p>
                            <p>
                                See more in <a className={"border-b"} href={"/downloads"}>all downloads</a>
                            </p>
                        </div>
                    </div>
                </motion.div>


                <motion.div
                    key={"mobile-apps-block"}
                    initial="initial"
                    animate="animate"
                    variants={{
                        initial: {
                            opacity: 0,
                            y: 50
                        },
                        animate: {
                            opacity: 1,
                            y: 0,
                            transition: {
                                delay: 0.3,
                                duration: 0.3,
                            }
                        },
                    }}
                >
                    <div className={"text-center mt-24"}>
                        <h1 className={"text-xl"}>Prefer <span className={"font-bold"}>mobile apps?</span> We have them too!</h1>
                        <div className={"flex justify-center flex-col md:flex-row"}>
                            <img
                                onClick={() => navigateToApp(
                                    "https://apps.apple.com/us/app/the-bullish-trade/id6466982556",
                                    "app-store", "ios-app")}
                                className={"h-14 mt-3 object-contain"}
                                src={"/appstore.svg"} alt={"Download on the App Store"}/>
                            {/*<a*/}
                            {/*    href='https://play.google.com/store/apps/details?id=trade.thebullish.app&pli=1&utm_source=the_bullish_landing&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>*/}
                            <img
                                onClick={() => navigateToApp(
                                    "https://play.google.com/store/apps/details?id=trade.thebullish.app&pli=1&utm_source=the_bullish_landing&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
                                    "play-store", "android-app")}
                                className={"h-20 cursor-pointer object-contain"}
                                alt='Get it on Google Play'
                                src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
                            {/*</a>*/}

                        </div>
                    </div>
                </motion.div>


                <motion.div
                    key={"landing-block-2"}
                    initial="initial"
                    animate="animate"
                    whileInView="visible"
                    viewport={{once: true}}
                    variants={{
                        initial: {
                            opacity: 0,
                            y: 50
                        },
                        visible: {
                            opacity: 1,
                            y: 0,
                            transition: {
                                duration: 0.5,
                            }
                        },
                        hidden: {opacity: 0, scale: 0},
                    }}
                >
                    <div className={"flex flex-col lg:flex-row mt-16"}>
                        <div
                            className={"flex justify-center w-full lg:w-1/2 mt-5 flex-shrink"}>
                            <div>
                                <LandingBlockHowDoesItHelp/>
                            </div>
                        </div>

                        <div className={"bg-lime-300 overflow-clip w-full lg:w-1/2 mt-10 lg:mt-0 lg:rounded-l-xl"}>
                            <div className={"hidden md:block image-feature-center-1-desktop-v2"}></div>
                            <div className={"p-0"}>
                                <div className={"block md:hidden image-feature-center-1-mob"}></div>
                            </div>
                        </div>
                    </div>
                </motion.div>


                <motion.div
                    key={"landing-block-3"}
                    initial="initial"
                    animate="animate"
                    whileInView="visible"
                    viewport={{once: true}}
                    variants={{
                        initial: {
                            opacity: 0,
                            y: 50
                        },
                        visible: {
                            opacity: 1,
                            y: 0,
                            transition: {
                                duration: 0.5,
                            }
                        },
                        hidden: {opacity: 0, scale: 0},
                    }}
                >
                    <div className={"flex flex-col lg:flex-row mt-24"}>
                        <div className={"hidden lg:block w-full lg:w-1/2"}>
                            <div className={"bg-pink-300 overflow-clip w-auto lg:rounded-r-xl"}>
                                <div className={"hidden md:block lg:block image-feature-center-2-desktop-v2 "}></div>
                                <div className={""}>
                                    <div className={"block md:hidden lg:hidden image-feature-center-2-mob mt-5"}></div>
                                </div>
                            </div>
                        </div>


                        <div
                            className={"flex justify-center w-full lg:w-1/2 mt-5 flex-shrink"}>
                            <div>
                                <LandingBlockHowDoesItWork/>
                            </div>
                        </div>

                        <div className={"w-full mt-10 lg:hidden"}>
                            <div className={"bg-pink-300 overflow-clip w-auto lg:rounded-r-xl"}>
                                <div className={"hidden md:block lg:block image-feature-center-2-desktop-v2 "}></div>
                                <div className={""}>
                                    <div className={"block md:hidden lg:hidden image-feature-center-2-mob mt-5"}></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </motion.div>



                <motion.div
                    key={"landing-block-4"}
                    initial="initial"
                    animate="animate"
                    whileInView="visible"
                    viewport={{once: true}}
                    variants={{
                        initial: {
                            opacity: 0,
                            y: 50
                        },
                        visible: {
                            opacity: 1,
                            y: 0,
                            transition: {
                                duration: 0.5,
                            }
                        },
                        hidden: {opacity: 0, scale: 0},
                    }}
                >
                <div className={"flex flex-col lg:flex-row mt-16"}>
                    <div
                        className={"flex justify-center w-full lg:w-1/2 mt-5 flex-shrink"}>
                        <div>
                            <LandingBlockIWantToTry/>
                        </div>
                    </div>

                    <div className={"bg-sky-300 overflow-clip w-full lg:w-1/2 mt-10 lg:mt-0 md:rounded-l-xl"}>
                        <div className={"hidden lg:block image-feature-center-4-desktop-v2"}></div>
                        <div className={"p-0"}>
                            <div className={"block lg:hidden image-feature-center-3-mob"}></div>
                        </div>
                    </div>
                </div>
                </motion.div>

                <motion.div
                    key={"landing-block-5"}
                    initial="initial"
                    animate="animate"
                    whileInView="visible"
                    viewport={{once: true}}
                    variants={{
                        initial: {
                            opacity: 0,
                            y: 50
                        },
                        visible: {
                            opacity: 1,
                            y: 0,
                            transition: {
                                duration: 0.5,
                            }
                        },
                        hidden: {opacity: 0, scale: 0},
                    }}
                >
                    <div className={"flex flex-col lg:flex-row mt-16"}>
                        <div className={"hidden lg:block w-full lg:w-1/2"}>
                            <div className={"bg-pink-300 overflow-clip w-auto lg:rounded-r-xl"}>
                                <div className={"hidden md:block lg:block image-feature-center-5-desktop-v2 "}></div>
                                <div className={""}>
                                    <div className={"block md:hidden lg:hidden image-feature-center-5-mob mt-5"}></div>
                                </div>
                            </div>
                        </div>


                        <div
                            className={"flex justify-center w-full lg:w-1/2 mt-5 flex-shrink"}>
                            <div>
                                <LandingBlockPlatforms/>
                            </div>
                        </div>

                        <div className={"w-full mt-10 lg:hidden"}>
                            <div className={"bg-pink-300 overflow-clip w-auto lg:rounded-r-xl"}>
                                <div className={"hidden md:block lg:block image-feature-center-5-desktop-v2 "}></div>
                                <div className={""}>
                                    <div className={"block md:hidden lg:hidden image-feature-center-5-mob mt-5"}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>


                {/*<div className={"flex flex-col lg:flex-row mt-16"}>*/}

                {/*    <div className={"w-full lg:w-1/2"}>*/}
                {/*        <div className={"bg-slate-400 overflow-clip w-auto lg:rounded-r-xl"}>*/}
                {/*            <div className={"hidden md:block lg:block pt-10 "}>*/}
                {/*                <div className={" image-feature-center-4-desktop-v2"}></div>*/}
                {/*            </div>*/}
                {/*            <div className={""}>*/}
                {/*                <div className={"block md:hidden lg:hidden image-feature-center-2-mob mt-5"}></div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*    <div className={"w-full lg:w-1/2 flex justify-center "}>*/}

                {/*        <div className={"mt-16 lg:mt-24 md:pl-5 lg:pl-8"}>*/}
                {/*            <LandingBlockIWantToTry/>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div
                    className={"mt-20 lg:mt-32  text-center"}>
                    <LandingBlockPricing/>
                </div>


                <div className={"mt-20 flex flex-row justify-center"}>
                    <div>
                        <span onClick={() => navigateToApp("https://app.thebullish.trade", "app", "mid-signup-free")}
                              className={"cursor-pointer bg-sky-400 text-white px-8 py-4 text-xl font-bold rounded-xl"}>SIGNUP FOR
                            FREE</span>
                        <div className={"mt-5 text-center"}>
                            <span className={"text-xs text-gray-400"}>No credit card required. Instant signup.</span>
                        </div>
                    </div>
                </div>

                <div className={"mt-16 flex flex-col lg:flex-row"}>
                    <div className={"flex justify-center text-2xl w-full lg:w-1/2 mt-7 "}>
                        <div
                            className={"mt-16 lg:mt-24"}>
                            <LandingBlockExplainSimpler/>
                        </div>
                    </div>


                    <div className={"w-full lg:w-1/2"}>
                        <div className={"hidden md:block lg:block mt-16 bg-teal-400 overflow-clip lg:rounded-l-xl"}>
                            <div className={"hidden md:block lg:block image-feature-center-3-desktop-v2 "}></div>
                        </div>

                        <div
                            className={"block md:hidden lg:hidden mt-16 bg-teal-400 overflow-clip lg:rounded-xl mx-auto"}
                            style={{width: '100%', height: 420}}>
                            <div className={"pt-5"}>
                                <div className={"block md:hidden lg:hidden image-feature-center-3-mob mt-5"}></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"mt-24 lg:mt-52 flex flex-row justify-center"}>
                    <div>
                        <span onClick={() => navigateToApp("https://app.thebullish.trade", "app", "cool-lets-trade")}
                              className={"cursor-pointer bg-emerald-500 text-white px-8 py-4 text-xl font-bold rounded-xl"}>{`Cool. Let's start!`}</span>
                        <div className={"mt-5 text-center"}>
                            <span className={"text-xs text-gray-400"}>No credit card required. Instant signup</span>
                        </div>
                    </div>
                </div>


                <div className={"mt-10 px-4"}>
                    <EmailForm trackEmailSubscription={trackEmailSubscription}/>
                </div>


                <div className={"h-20"}>


                </div>
            </section>


            <Footer/>

            {/*<CrispChat/>*/}
        </main>

    )
}
